import { Controller } from "@hotwired/stimulus";

// Controller: ptd-restore
// Orchestrates restoring a TableDefinition in its branch, then marking the
// PromotionTableDefinition as restored.
// Expected data values:
// - data-ptd-restore-td-id-value: TableDefinition ID
// - data-ptd-restore-ptd-url-value: URL to PATCH /promotion_table_definitions/:id/restore
export default class extends Controller {
  static values = {
    tdId: Number,
    ptdUrl: String,
    redirectUrl: String
  }

  stop(event) {
    // Prevent navigating the wrapping link card and default anchor behavior
    event.preventDefault();
    event.stopPropagation();
  }

  async restore(event) {
    event.preventDefault();
    event.stopPropagation();

    // Only proceed if explicitly triggered by the confirm button
    const role = event.currentTarget?.dataset?.role;
    if (role !== 'confirm') return;

    const tdId = this.tdIdValue;

    if (!tdId) return;

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Proactively close the modal overlay for immediate UX feedback
    const overlay = this.element.querySelector('[data-modal-target="overlay"]');
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.classList.remove('flex');
    }
    document.body.classList.remove('overflow-hidden');

    try {
      // Call the TableDefinitionsController restore endpoint
      const tdRes = await fetch(`/table_definitions/${tdId}/restore`, {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html, text/html, application/json',
          'X-CSRF-Token': token
        }
      });
      if (!tdRes.ok) {
        console.error('Failed to restore table_definition', await tdRes.text());
        return;
      }

      // Refresh the promotion screen (Turbo-aware navigation)
      if (this.hasRedirectUrlValue && this.redirectUrlValue) {
        // Add cache-busting param to ensure fresh content
        const targetUrl = new URL(this.redirectUrlValue, window.location.origin);
        targetUrl.searchParams.set('ts', Date.now().toString());
        const finalUrl = targetUrl.toString();
        if (window.Turbo && typeof window.Turbo.visit === 'function') {
          window.Turbo.visit(finalUrl);
        } else {
          window.location.href = finalUrl;
        }
      } else {
        window.location.reload();
      }
    } catch (e) {
      console.error('Restore error', e);
    }
  }
}
